import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from "../../store/actions/actions";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import italianOtpTranslations from "../../translations/otp/it.otp.json";
import englishOtpTranslations from "../../translations/otp/en.otp.json";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

class Otp extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianOtpTranslations, "it");
    this.props.addTranslationForLanguage(englishOtpTranslations, "en");
  }

  componentDidMount() {
    this.props.setActiveLanguage(this.props.language)
  }

  submitHandler = (event) => {
    event.preventDefault();
    let otp = event.target.otp.value;
    const data = {otp};
    this.props.otp(data)
  }

  invalidateSession=()=>{
    // event.preventDefault();
    this.props.invalidateSession();

  }

  resendOtp=()=>{
    // event.preventDefault();
    let OtpData={username:this.props.username,token:this.props.token}
    this.props.resendOtp(OtpData);
  }

  render() {

    let errors="";
    let hasError=false
    let errorMessage = ""
    if(this.props.validationError !== "" && this.props.validationError !== null && this.props.validationError.config.url === '/otp') {
      errors = this.props.validationError;
      if (errors !== null && errors !== "" && errors !== undefined) {
        if (errors.status === 401) {
          errorMessage = <Translate id="otp.403" data={{statusText: errors.data.message}}/>
        } else if (errors.status === 403) {
          errorMessage = <Translate id="otp.403" data={{statusText: errors.data.message}}/>
        } else if (errors.status === 400) {
          errorMessage = <Translate id="otp.connection" data={{statusText: errors.data.message}}/>
        } else if (errors.status === 500) {
          errorMessage = <Translate id="otp.500" data={{statusText: errors.data.message}}/>
        } else if (errors.status === 404) {
          errorMessage = <Translate id="otp.404" data={{statusText: errors.statusText}}/>
        }
        hasError = true
      }
    }
    return (
        <>
          <Col lg="5" md="7" className="mt--9">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>
                    <Translate id="otp.title"/>
                  </small>
                </div>
                <div className={hasError === true ? "text-center text-muted mb-4" : "noErrors"}>
                  <small className={hasError === true ? "highlight":""}>{errorMessage}</small>
                </div>
                <form onSubmit={this.submitHandler}>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="otp"
                             required
                             label={translate("otp.otp")}
                             placeholder={translate("otp.otp")}
                             type="text"
                             autoComplete="OTP"/>}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <div className="text-center">
                    <Button className="my-4" type="submit" variant="contained" color="primary">
                      <Translate id="otp.button.verify"/>
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
            <Row className="mt-3">
              <div className={"col"}>
                <a
                    className="text-light"
                    href="#"
                    onClick={event => this.invalidateSession()}
                >
                {/*<Button onClick={this.invalidateSession}>*/}
                  <small><Translate id="otp.invalidate.session" data={{ mark: "?" }}/></small>
                {/*</Button>*/}
                </a>
              </div>
              <div className={"col text-right"}>
                <a
                    className="text-light"
                    href="#"
                    onClick={e => this.resendOtp()}
                >
                  <small><Translate id="otp.retry" data={{ mark: "?" }}/></small>
                </a>
              </div>
            </Row>
          </Col>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.authentication.authenticatedUser.token,
    language: state.authentication.authenticatedUser.language,
    validationError:state.authentication.error,
    username:state.authentication.authenticatedUser.username
  }
}

const mapDispatchToProps = dispatch => {
  return {
    otp: (data) => dispatch({type: actions.AUTHENTICATION_OTP_REQUEST, value: data}),
    invalidateSession:() => dispatch({type:actions.AUTHENTICATION_INVALIDATE_SESSION}),
    resendOtp:(otpData) => dispatch({type:actions.AUTHENTICATION_RESEND_OTP,value:otpData})
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Otp));